import React, { useCallback, useState } from "react";
import { Redirect } from "react-router-dom";
import { PlainButton } from "@culturehq/components";

import { useQueryString } from "app/context";
import { getRecognitionPath } from "app/links";
import { Trans } from "app/utils";

import RecognitionModal from "./RecognitionModal";

const NoRecognitions = () => {
  const { onClearQueryString } = useQueryString();
  const [redirect, setRedirect] = useState(null);

  const onCreate = useCallback(
    recognition => setRedirect(getRecognitionPath(recognition)),
    [setRedirect]
  );

  if (redirect) {
    return <Redirect to={redirect} />;
  }

  return (
    <div className="EmptyResults EmptyResults-recognitions">
      <h2>
        <Trans>Oh no, you ran out of results...</Trans>
      </h2>
      <h3>
        <Trans>What would you like to do next?</Trans>
      </h3>
      <RecognitionModal checkState={false} onCreate={onCreate}>
        {onTrigger => (
          <PlainButton className="button" onClick={onTrigger}>
            <Trans>Give Recognition</Trans>
          </PlainButton>
        )}
      </RecognitionModal>
      <br />
      <PlainButton onClick={onClearQueryString}>
        <Trans>Start over</Trans>
      </PlainButton>
    </div>
  );
};

export default NoRecognitions;
